import PropTypes from "prop-types"
import SharedDialog from "../../../dialogs/SharedDialog"

const DeleteTranslationDialog = ({ open, closeDialog, onDelete }) => {
  return (
    <SharedDialog
      isOpen={open}
      onClose={() => {
        closeDialog()
      }}
      action={() => {
        onDelete()
        closeDialog()
      }}
      actionTitle="Delete"
      actionType="delete"
    >
      <div>
        <h2 className="text-2xl text-primary mb-5 font-semibold">
          Delete Translation
        </h2>
        <p className="text-lg">
          Are you sure you want to delete this translation?
        </p>
      </div>
    </SharedDialog>
  )
}

DeleteTranslationDialog.propTypes = {
  open: PropTypes.bool,
  closeDialog: PropTypes.func,
  onDelete: PropTypes.func,
}

export default DeleteTranslationDialog
